import { Autocomplete, Chip, TextField } from '@mui/material';
import { Controller, type Control } from 'react-hook-form';

import type { ProfesionalFormValues } from '../schemas';

interface EmailsFieldProps {
  control: Control<ProfesionalFormValues>;
  disabled?: boolean;
}

export function EmailsField({ control, disabled }: EmailsFieldProps): JSX.Element {
  return (
    <Controller
      name="emails"
      control={control}
      render={({ field, fieldState }) => (
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={field.value}
          onChange={(_, newValue) => {
            const cleaned = newValue
              .map((v) => (typeof v === 'string' ? v.trim().toLowerCase() : v))
              .filter((v) => v.length > 0);
            field.onChange(cleaned);
          }}
          disabled={disabled}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const tagProps = getTagProps({ index });
              return <Chip variant="outlined" label={option} {...tagProps} key={option} />;
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Emails"
              placeholder="Escribí un email y presioná Enter"
              error={!!fieldState.error}
              helperText={
                fieldState.error?.message ??
                'Podés agregar varios emails. Presioná Enter después de cada uno.'
              }
              onBlur={field.onBlur}
            />
          )}
        />
      )}
    />
  );
}
